import { range } from '@/packages/utils/array/range';

import { type PaginationItem } from '../../../types/pagination';

type PreparePaginationOptions = {
  currentPage: number;
  totalPages: number;
};

export const PAGINATION_WIDTH = 7;

export function preparePagination(options: PreparePaginationOptions): PaginationItem[] {
  const { totalPages, currentPage } = options;
  // если общее количеств страниц не больше кол-ва элементов в блоке PAGINATION_WIDTH, выводим все
  if (totalPages <= PAGINATION_WIDTH) {
    return range(1, totalPages).map(page =>
      preparePage({
        currentPage,
        id: page.toString(),
        page,
        title: page.toString(),
      }),
    );
  }

  const pagination: PaginationItem[] = [];

  // В блоке пагинации всегда отображаем 1 страницу
  // [1] [startPage] [ ] [ ] [ ] [ ] [endPage]
  pagination.push(preparePage({ currentPage, id: '1', page: 1, title: '1' }));

  const endPage = Math.min(Math.max(PAGINATION_WIDTH, currentPage + 3), totalPages);
  const startPage = endPage - 5;

  const mainRange = range(startPage, endPage);

  mainRange.forEach((page, index) => {
    let title: string;

    if ((index === 0 && page > 2) || (index === mainRange.length - 1 && page < totalPages)) {
      title = '...';
    }

    title ??= page.toString();

    pagination.push(preparePage({ currentPage, id: page.toString(), page, title }));
  });

  return pagination;
}

type PreparePageOptions = {
  currentPage: number;
  id: string;
  page: number;
  title: string;
};

function preparePage({ page, currentPage, title, id }: PreparePageOptions): PaginationItem {
  return {
    disabled: page === currentPage,
    id,
    page,
    title,
  };
}
